var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pb-4",attrs:{"id":"app"}},[_c('router-view',{attrs:{"first_name":_vm.first_name,"last_name":_vm.last_name,"email":_vm.email},on:{"updateField":function($event){return _vm.updateField($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }